import { EmptyStatePage, EventProps, ValueProps } from './EmptyStatePage'
import { AppState, Dispatch } from '../../types'
import { connect } from 'react-redux';
import * as actions from './actions';
import selectors from './selectors'

const mapProps = (state: AppState): ValueProps => ({
  is404: selectors.is404(state),
  emptyStateTitle: selectors.emptyStateTitle(state),
  emptyStateSubtitle: selectors.emptyStateSubtitle(state),
  redirectLink: selectors.redirectLink(state)
});

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  handleRedirection: (href: string) => dispatch(actions.handleRedirection(href))
});

export default connect(mapProps, mapDispatch)(EmptyStatePage)
